export default __webpack_public_path__ + "f19c7ab7d20e0ee31d5e24c8a9f824ad.svg";